// import { createSlice } from "@reduxjs/toolkit";

// interface SidebarState {
//   open: boolean;
// }

// const initialState: SidebarState = {
//   open: false,
// };

// const sidebarSlice = createSlice({
//   name: "sidebar",
//   initialState,
//   reducers: {
//     toggleSidebar: (state) => {
//       state.open = !state.open;
//     },
//     openSidebar: (state) => {
//       state.open = true;
//     },
//     closeSidebar: (state) => {
//       state.open = true;
//     },
//   },
// });

// export const { toggleSidebar, openSidebar, closeSidebar } =
//   sidebarSlice.actions;
// export default sidebarSlice.reducer;

import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface SidebarState {
  manualOpen: boolean;
  hoverOpen: boolean;
}

const initialState: SidebarState = {
  manualOpen: false,
  hoverOpen: false,
};

const sidebarSlice = createSlice({
  name: "sidebar",
  initialState,
  reducers: {
    toggleManualOpen: (state) => {
      state.manualOpen = !state.manualOpen;
    },
    setHoverOpen: (state, action: PayloadAction<boolean>) => {
      state.hoverOpen = action.payload;
    },
    // optional: reset both states
    closeSidebar: (state) => {
      state.manualOpen = false;
      state.hoverOpen = false;
    },
  },
});

export const { toggleManualOpen, setHoverOpen, closeSidebar } =
  sidebarSlice.actions;
export default sidebarSlice.reducer;
